import { useSelector } from "react-redux";
import { selectWorldCupResult } from "./WorldCupResultSlice";
import { intArray } from "./utils";

export default function WorldCup16TeamMobileBracket(props) {
    const { width, height, xMargin, firstRoundYMargin } = { ...props };
    return <svg
        width={width * 8 + xMargin * 3}
        height={height * 16 + firstRoundYMargin * 7}
        style={{ margin: "auto", display: "block" }}
    >
        {RoundOf16(props)}
        {QuarterFinals(props)}
        {SemiFinals(props)}
        {Finals(props)}
        {Winner(props)}
    </svg>;
}

function Team(props) {

    const { code, x, y, width, height } = { ...props };
    return <g>
        {code && <image
            x={x}
            y={y}
            width={width}
            height={height}
            href={"https://api.fifa.com/api/v3/picture/flags-sq-1/" + code}
        />}
        {code && <text
            x={x + width * 1.5}
            y={y + height * 0.5}
            fill="white"
            fontFamily="monospace"
            fontSize="14px"
            fontWeight="bold"
            alignmentBaseline="middle"
            textAnchor="middle">
            {code}
        </text>}
        <rect
            x={x}
            y={y}
            width={width * 2}
            height={height}
            stroke="white"
            fillOpacity={0}
        />
    </g>;
}

function WinnerTeam(props) {

    const { code, x, y, width, height } = { ...props };
    return <g>
        {code && <image
            x={x}
            y={y}
            width={width * 2}
            height={height * 2}
            href={"https://api.fifa.com/api/v3/picture/flags-sq-3/" + code}
        />}
        {code && <text
            x={x + width}
            y={y + height * 3}
            fill="white"
            fontFamily="monospace"
            fontSize="28px"
            fontWeight="bold"
            alignmentBaseline="middle"
            textAnchor="middle">
            {code}
        </text>}
        <rect
            x={x}
            y={y}
            width={width * 2}
            height={height * 4}
            stroke="white"
            fillOpacity={0}
        />
    </g>;
}

function RoundOf16(props) {
    const { width, height, xMargin, firstRoundYMargin } = { ...props };
    const result = useSelector(selectWorldCupResult);
    const x = 0;
    const y = 0;
    const yMargin = firstRoundYMargin;
    return <g>
        {intArray(8).map(i => {
            let team1, team2;
            if (result.roundOf16 && result.roundOf16[i]) {
                team1 = result.roundOf16[i].team1;
                team2 = result.roundOf16[i].team2;
            }
            return <g key={i}>
                <Team
                    code={team1}
                    x={x}
                    y={y + height * i * 2 + yMargin * i}
                    width={width}
                    height={height}
                />
                <Team
                    code={team2}
                    x={x}
                    y={y + height * (i * 2 + 1) + yMargin * i}
                    width={width}
                    height={height}
                />
            </g>;
        })}
        {intArray(4).map(i => <g key={i}>
            <line x1={x + width * 2} y1={y + height + (height * 4 + yMargin * 2) * i} x2={x + width * 2 + xMargin * 0.5} y2={y + height + (height * 4 + yMargin * 2) * i} stroke="white" />
            <line x1={x + width * 2} y1={y + height * 3 + yMargin + (height * 4 + yMargin * 2) * i} x2={x + width * 2 + xMargin * 0.5} y2={y + height * 3 + yMargin + (height * 4 + yMargin * 2) * i} stroke="white" />
            <line x1={x + width * 2 + xMargin * 0.5} y1={y + height + (height * 4 + yMargin * 2) * i} x2={x + width * 2 + xMargin * 0.5} y2={y + height * 3 + yMargin + (height * 4 + yMargin * 2) * i} stroke="white" />
            <line x1={x + width * 2 + xMargin * 0.5} y1={y + height * 2 + yMargin * 0.5 + (height * 4 + yMargin * 2) * i} x2={x + width * 2 + xMargin} y2={y + height * 2 + yMargin * 0.5 + (height * 4 + yMargin * 2) * i} stroke="white" />
        </g>
        )}
    </g>;
}

function QuarterFinals(props) {
    const { width, height, xMargin, firstRoundYMargin } = { ...props };
    const result = useSelector(selectWorldCupResult);
    const x = width * 2 + xMargin;
    const y = height + firstRoundYMargin * 0.5;
    const yMargin = height * 2 + firstRoundYMargin * 2;
    return <g>
        {intArray(4).map(i => {
            let team1, team2;
            if (result.quarterFinals && result.quarterFinals[i]) {
                team1 = result.quarterFinals[i].team1;
                team2 = result.quarterFinals[i].team2;
            }
            return <g key={i}>
                <Team
                    code={team1}
                    x={x}
                    y={y + height * i * 2 + yMargin * i}
                    width={width}
                    height={height}
                />
                <Team
                    code={team2}
                    x={x}
                    y={y + height * (i * 2 + 1) + yMargin * i}
                    width={width}
                    height={height}
                />
            </g>;
        })}
        {intArray(2).map(i => <g key={i}>
            <line x1={x + width * 2} y1={y + height + (height * 4 + yMargin * 2) * i} x2={x + width * 2 + xMargin * 0.5} y2={y + height + (height * 4 + yMargin * 2) * i} stroke="white" />
            <line x1={x + width * 2} y1={y + height * 3 + yMargin + (height * 4 + yMargin * 2) * i} x2={x + width * 2 + xMargin * 0.5} y2={y + height * 3 + yMargin + (height * 4 + yMargin * 2) * i} stroke="white" />
            <line x1={x + width * 2 + xMargin * 0.5} y1={y + height + (height * 4 + yMargin * 2) * i} x2={x + width * 2 + xMargin * 0.5} y2={y + height * 3 + yMargin + (height * 4 + yMargin * 2) * i} stroke="white" />
            <line x1={x + width * 2 + xMargin * 0.5} y1={y + height * 2 + yMargin * 0.5 + (height * 4 + yMargin * 2) * i} x2={x + width * 2 + xMargin} y2={y + height * 2 + yMargin * 0.5 + (height * 4 + yMargin * 2) * i} stroke="white" />
        </g>
        )}
    </g>;
}

function SemiFinals(props) {
    const { width, height, xMargin, firstRoundYMargin } = { ...props };
    const result = useSelector(selectWorldCupResult);
    const x = width * 4 + xMargin * 2;
    const y = height * 3 + firstRoundYMargin * 1.5;
    const yMargin = height * 6 + firstRoundYMargin * 4;
    return <g>
        {intArray(2).map(i => {
            let team1, team2;
            if (result.semiFinals && result.semiFinals[i]) {
                team1 = result.semiFinals[i].team1;
                team2 = result.semiFinals[i].team2;
            }
            return <g key={i}>
                <Team
                    code={team1}
                    x={x}
                    y={y + height * i * 2 + yMargin * i}
                    width={width}
                    height={height}
                />
                <Team
                    code={team2}
                    x={x}
                    y={y + height * (i * 2 + 1) + yMargin * i}
                    width={width}
                    height={height}
                />
                <line x1={x + width * 2} y1={y + height} x2={x + width * 2 + xMargin * 0.5} y2={y + height} stroke="white" />
                <line x1={x + width * 2} y1={y + height * 3 + yMargin} x2={x + width * 2 + xMargin * 0.5} y2={y + height * 3 + yMargin} stroke="white" />
                <line x1={x + width * 2 + xMargin * 0.5} y1={y + height} x2={x + width * 2 + xMargin * 0.5} y2={y + height * 3 + yMargin} stroke="white" />
                <line x1={x + width * 2 + xMargin * 0.5} y1={y + height * 2 + yMargin * 0.5} x2={x + width * 2 + xMargin} y2={y + height * 2 + yMargin * 0.5} stroke="white" />
            </g>;
        })}
    </g>;
}

function Finals(props) {
    const { width, height, xMargin, firstRoundYMargin } = { ...props };
    const result = useSelector(selectWorldCupResult);
    const finals = result.finals;
    const x = width * 6 + xMargin * 3;
    const y = height * 7 + firstRoundYMargin * 3.5;
    return <g>
        <Team
            code={finals?.team1}
            x={x}
            y={y}
            width={width}
            height={height}
        />
        <Team
            code={finals?.team2}
            x={x}
            y={y + height}
            width={width}
            height={height}
        />
    </g>;
}

function Winner(props) {
    const { width, height, xMargin, firstRoundYMargin } = { ...props };
    const result = useSelector(selectWorldCupResult);
    let code;
    if (Number.isInteger(result.finals?.goal1) && Number.isInteger(result.finals?.goal2)) {
        const goal1 = result.finals.goal1;
        const goal2 = result.finals.goal2;
        const psoWinner = result.finals.psoWinner;
        if (goal1 > goal2) {
            code = result.finals.team1;
        } else if (goal2 > goal1) {
            code = result.finals.team2;
        } else if (psoWinner === 1) {
            code = result.finals.team1;
        } else if (psoWinner === 2) {
            code = result.finals.team2;
        }
    }
    const x = width * 4 + xMargin * 2;
    const y = height * 6 + firstRoundYMargin * 3.5;
    return <WinnerTeam code={code} x={x} y={y} width={width} height={height} />;
}